import { evaluateBoolExpr, type FlowDocument } from '@miso/design-system';

/**
 * Sub-stage 의 진입 위치를 "마지막 활성 질문" 으로 이동시키기 위한 헬퍼.
 *
 * 이전 sub-stage 로 뒤로가기 했을 때 첫 질문이 아닌 **마지막에 답한 질문** 부터
 * 다시 보여줘야 한다는 요구사항을 만족시키기 위해 사용된다.
 *
 * - 주어진 `stepId` 가 questions step 이 아니면 `undefined`.
 * - 각 question 의 `skipIf` 를 `values` 기준으로 평가해 활성 여부를 판단한다.
 * - 끝에서부터 스캔하여 처음 만나는 visible question id 를 반환한다.
 * - switchTo variant 는 InquiryFlow 가 primary slot 만 노출하므로 여기서도 primary
 *   slot 의 id 를 그대로 돌려준다 (`questions.findIndex` 매칭 호환).
 *
 * `evaluateBoolExpr` 실행 중 예외가 발생하면 (정상 흐름에서는 없음) 안전하게
 * 활성 처리하여 fallback 한다.
 */
export function findLastVisibleQuestionId(
  flow: FlowDocument,
  stepId: string,
  values: Record<string, unknown>
): string | undefined {
  const step = flow.steps[stepId];
  if (!step || step.kind !== 'questions') return undefined;
  for (let i = step.questions.length - 1; i >= 0; i--) {
    const q = step.questions[i];
    if (!q.skipIf) return q.id;
    try {
      if (!evaluateBoolExpr(q.skipIf, values)) return q.id;
    } catch {
      return q.id;
    }
  }
  return undefined;
}
